/*
 * Copyright (C) 2017-2019 Dremio Corporation. This file is confidential and private property.
 */

export const AUTH_METHOD = 'auth_method';
export const COOKIE_CONSENT = 'cookie_consent';
export const ORG_ID = 'org';
export const USERNAME = 'username';
